import { useEffect, useState } from 'react'
import { Col, Form, Card, Button, ButtonToolbar } from 'react-bootstrap'
import { Alert, AlertTitle } from '@material-ui/lab'
import NoteAddIcon from '@material-ui/icons/NoteAdd'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import SaveIcon from '@material-ui/icons/Save'
import api from '../../services/api'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

import ToastAnimated, { showToast } from '../../ui-lib/toast'
import 'react-toastify/dist/ReactToastify.css'
function CorpoPedidoUnic({ data }) {
  const [body, setBody] = useState([])
  const [id, setId] = useState(data.id)
  const [name_user, setName_user] = useState(data.id_user)
  const [email, setEmail] = useState(data.requerente)
  const [empresa, setEmpresa] = useState(data.idEmpresa)
  const [prioridade, setPrioridade] = useState(data.prioridade)
  const [natureza, setNatureza] = useState(data.tipo_chamado)
  const [origem, setOrigem] = useState(data.origem)
  const [tipoHist, setTipoHist] = useState('')
  const [temp_g, setTemp_g] = useState('')
  const [dataAber, setDataAber] = useState(data.data_abertura)
  const [hist_msg, setHist_msg] = useState('')
  const [status, setStatus] = useState(data.status)
  const [assunto, setAssunto] = useState(data.assunto)
  const [obs, setObs] = useState(data.corpo_chamado)

  const refreshPage = () => {
    window.location.reload()
  }
  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [year, month, day].join('-')
  }
  async function handleUpdatePedido() {
    await api
      .put('/chamados', {
        id: data.id,
        idEmpresa: empresa,
        id_user: name_user,
        tipo_chamado: natureza,
        requerente: email,
        prioridade: prioridade,
        corpo_chamado: obs,
        assunto: assunto,
        tecnico: data.tecnico,
        origem: origem,
        data_abertura: dataAber,
        status: status,
      })
      .then(() => {
        return refreshPage()
      })
      .catch((err) => {
        console.error(err)
        showToast({ type: 'error', message: 'Erro ao cadastrar pedido' })
      })
  }
  async function handleInsetHistorico() {
    console.log(status)
    await api
      .post('/chamados/historico', {
        id_chamados: data.id,
        msg: hist_msg,
        tipo_msg: tipoHist,
        data: new Date(),
        temp_g: temp_g,
        tecnico: data.tecnico,
        idEmpresa: empresa,
      })
      .then(async () => {
        await api
          .put('/chamados', {
            id: data.id,
            idEmpresa: empresa,
            id_user: name_user,
            tipo_chamado: natureza,
            requerente: email,
            prioridade: prioridade,
            corpo_chamado: obs,
            assunto: assunto,
            tecnico: data.tecnico,
            origem: origem,
            data_abertura: dataAber,
            status: status,
          })
          .then(() => {
            return refreshPage()
          })
      })
      .catch(() => {
        showToast({ type: 'error', message: 'Erro ao cadastrar historico' })
      })
  }
  useEffect(() => {
    ; (async () => {
      api.get('/chamados/historico?id=' + data.id).then((response) => {
        const result = response.data
        setBody(result)
      })
    })()
  }, [])

  return (
    <div>
      <ToastAnimated />
      <Container component={Paper} elevation={6} maxWidth='xl'>
        <br />
        <Container elevation={4}>
          <Alert severity="info" variant="filled">
            <AlertTitle>Chamado numero {data.id}</AlertTitle>
            Atribuido para: {data.tecnico}
          </Alert>
        </Container>
        <br />
        <Form>
          <br />
          <Form.Group>
            <Container component={Paper} elevation={3}>
              <Form>
                <Form.Row className="align-items-center">
                  <Col>
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                      value={name_user}
                      onChange={(event) => {
                        setName_user(event.target.value)
                      }}
                      type="text"
                    />
                  </Col>

                  <Col>
                    <Form.Label>E-mail</Form.Label>
                    <Form.Control
                      value={email}
                      onChange={(event) => {
                        setEmail(event.target.value)
                      }}
                      type="text"
                    />
                  </Col>
                  <Col>
                    <Form.Label>Empresa</Form.Label>
                    <Form.Control
                      value={empresa}
                      onChange={(event) => {
                        setEmpresa(event.target.value)
                      }}
                      type="text"
                      placeholder="name@example.com"
                    />
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <Form.Label>Prioridade</Form.Label>
                    <Form.Control
                      value={prioridade}
                      onChange={(event) => {
                        setPrioridade(event.target.value)
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label>Tipo do chamado</Form.Label>
                    <Form.Control
                      value={natureza}
                      onChange={(event) => {
                        setNatureza(event.target.value)
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label>Status do chamado</Form.Label>
                    <Form.Control
                      value={status}
                      as="select"
                      onChange={(event) => {
                        setStatus(event.target.value)
                      }}
                    >
                      <option>Aberto</option>
                      <option>Em atendimento</option>
                      <option>Concluido</option>
                    </Form.Control>
                  </Col>
                </Form.Row>
              </Form>
              <br />
            </Container>
            <br />

            <br />
            <Container component={Paper} elevation={3}>
              <br />

              <Form>
                <Form.Row className="align-items-center"></Form.Row>
              </Form>
              <Form>
                <Form.Row>
                  <Col>
                    <Form.Label>Data da solicitação</Form.Label>
                    <Form.Control
                      type="date"
                      defaultValue={formatDate(data.data_abertura)}
                      onChange={(event) => {
                        setDataAber(event.target.value)
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Label>Origem</Form.Label>
                    <Form.Control
                      value={origem}
                      onChange={(event) => {
                        setOrigem(event.target.value)
                      }}
                      type="text"
                    />
                  </Col>
                </Form.Row>
              </Form>
              <Form.Label>Assunto do chamado</Form.Label>
              <Form.Control
                value={assunto}
                onChange={(event) => {
                  setAssunto(event.target.value)
                }}
              />
              <Form.Label>Chamado</Form.Label>
              <Form.Control
                value={obs}
                as="textarea"
                rows={5}
                onChange={(event) => {
                  setObs(event.target.value)
                }}
              />
              <br />
              <ButtonToolbar className="justify-content-between">
                <Button
                  size="sm"
                  variant="outline-dark"
                  aria-describedby="btnGroupAddon2"
                  onClick={handleUpdatePedido}
                >
                  {'\n '}
                  <SaveIcon fontSize="small" />
                  {'\n '}
                  Salvar Alterações
                </Button>
              </ButtonToolbar>
              <br />
              <br />
            </Container>
            <br />
            <Container component={Paper} elevation={3}>
              <Form>
                <Form.Row>
                  <Col>
                    <Form.Label>Historico</Form.Label>
                    <Form.Control
                      as="select"
                      defaultValue="Tipo do acompanhamento"
                      onChange={(event) => {
                        if (event.target.value === 'Conclusão') {
                          setStatus('Concluido')
                          setTipoHist(event.target.value)
                        } else {
                          setTipoHist(event.target.value)
                        }
                      }}
                    >
                      <option>Tipo do acompanhamento</option>
                      <option>Tarefa</option>
                      <option>Conclusão</option>
                    </Form.Control>
                  </Col>

                  <Col>
                    <Form.Label>Tempo gasto (Minutos)</Form.Label>
                    <Form.Control
                      type="number"
                      value={temp_g}
                      onChange={(event) => {
                        setTemp_g(event.target.value)
                      }}
                    />
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <br />
                    <Form.Control
                      as="textarea"
                      rows={4}
                      onChange={(event) => {
                        setHist_msg(event.target.value)
                      }}
                    />
                  </Col>
                </Form.Row>
                <br />
                <ButtonToolbar className="justify-content-between">
                  <Button
                    size="sm"
                    variant="outline-secondary"
                    aria-describedby="btnGroupAddon2"
                    onClick={handleInsetHistorico}
                  >
                    {'\n '}
                    <NoteAddIcon fontSize="small" />
                    {'\n '}
                    Registrar Historico
                  </Button>
                </ButtonToolbar>
              </Form>
              <br />
            </Container>
          </Form.Group>
        </Form>
        <Alert severity="success">
          <AlertTitle>Historico do chamado</AlertTitle>
        </Alert>
        <br />
        <Container component={Paper} elevation={3}>
          <br />
          {body.map((body) => {
            let status = ''
            function handleDelete() {
              api
                .delete('/chamados/historico?id=' + body.id)
                .then(() => {
                  return refreshPage()
                })
                .catch((request) => {
                  const result = request.body
                  return showToast({
                    type: 'error',
                    message: result,
                  })
                })
            }
            if (!body.tipo_msg) {
              status = 'danger'
            } else if (body.tipo_msg === 'Tarefa') {
              status = 'warning'
            } else if (body.tipo_msg === 'Conclusão') {
              status = 'success'
            }

            return (
              <Form key={body.id}>
                <Form.Row>
                  <br />
                  <Col xs="auto">
                    <Card border={status}>
                      <Card.Header>{body.tecnico}</Card.Header>
                      <Card.Body>
                        <blockquote className="blockquote mb-0">
                          <p> {body.msg} </p>
                          <footer className="blockquote-footer">
                            Tempo gasto:{' '}
                            <cite title="Source Title">
                              {body.temp_g} Minutos
                            </cite>
                          </footer>
                          <footer className="blockquote-footer">
                            Tipo do acompanhamento:{' '}
                            <cite title="Source Title">{body.tipo_msg}</cite>
                          </footer>
                        </blockquote>
                      </Card.Body>
                      <Card.Footer className="text-muted">
                        <Button variant="" onClick={handleDelete}>
                          <small>
                            Deletar <DeleteOutlineIcon fontSize="small" />
                          </small>
                        </Button>
                      </Card.Footer>
                    </Card>
                  </Col>
                </Form.Row>
              </Form>
            )
          })}
          <br />
        </Container>
        <br />
      </Container>
    </div>
  )
}

export default CorpoPedidoUnic
